export const ChatEngineEvents = {
  Chats: 'Chats',
  Contacts: 'Contacts',
  MyTeam: 'MyTeam',
  Invites: 'Invites',
  Counters: 'Counters',
  FavoritesCount: 'FavoritesCount',
  AllSubscribedChats: 'AllSubscribedChats'
} as const

export type ChatEngineEvent = typeof ChatEngineEvents[keyof typeof ChatEngineEvents]

export const ChatMarks = {
  Chat: 'chat',
  News: 'news',
  Divider: 'divider',
  Alogix: 'alogix'
} as const

export type ChatMark = typeof ChatMarks[keyof typeof ChatMarks]
